var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", width: "600" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline" },
            [
              _c(
                "v-flex",
                { attrs: { xs9: "" } },
                [
                  _c("v-icon", [_vm._v(_vm._s(_vm.form.id ? "edit" : "add"))]),
                  _vm._v(
                    "\n          " +
                      _vm._s(
                        _vm.form.id
                          ? "Editar Tipo Permiso"
                          : "Crear Tipo Permiso"
                      ) +
                      "\n        "
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.save.apply(null, arguments)
                }
              },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { md12: "", xs12: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "text-field-reducido-border",
                                attrs: {
                                  outline: "",
                                  label: "Tipo de permiso",
                                  rules: _vm.$validate(["required"]),
                                  required: ""
                                },
                                model: {
                                  value: _vm.form.descripcion,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "descripcion", $$v)
                                  },
                                  expression: "form.descripcion"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md12: "", xs12: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "text-field-reducido-border",
                                attrs: {
                                  outline: "",
                                  label: "Tolerancia",
                                  type: "time"
                                },
                                model: {
                                  value: _vm.form.tolerancia,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "tolerancia", $$v)
                                  },
                                  expression: "form.tolerancia"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md12: "", xs12: "" } },
                            [
                              _c("v-text-field", {
                                staticClass: "text-field-reducido-border",
                                attrs: {
                                  outline: "",
                                  label: "Plazo",
                                  type: "number"
                                },
                                model: {
                                  value: _vm.form.plazo,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "plazo", _vm._n($$v))
                                  },
                                  expression: "form.plazo"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            { attrs: { md6: "", xs12: "" } },
                            [
                              _c("p", [_vm._v("Refrigerio")]),
                              _vm._v(" "),
                              _c(
                                "v-radio-group",
                                {
                                  attrs: { row: "" },
                                  model: {
                                    value: _vm.form.refrigerio,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "refrigerio", $$v)
                                    },
                                    expression: "form.refrigerio"
                                  }
                                },
                                [
                                  _c("v-radio", {
                                    attrs: { label: "Sí", value: 1 }
                                  }),
                                  _vm._v(" "),
                                  _c("v-radio", {
                                    attrs: { label: "No", value: 0 }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("small", { staticClass: "error--text text-required" }, [
                    _vm._v("* Los campos son obligatorios")
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      nativeOn: {
                        click: function($event) {
                          return _vm.close()
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("cancel")]),
                      _vm._v(
                        " " + _vm._s(_vm.$t("common.cancel")) + "\n          "
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        type: "submit",
                        loading: _vm.loading,
                        disabled: !_vm.valid
                      }
                    },
                    [
                      _c("v-icon", { attrs: { dark: "" } }, [_vm._v("check")]),
                      _vm._v(
                        " " + _vm._s(_vm.$t("common.save")) + "\n          "
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-101f50b3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-101f50b3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/tipo_permiso/dialogs/CrearActualizarTipoPermiso.vue
// module id = null
// module chunks = 